/* =========================================================
   Türchenbau – Theme-JavaScript (Vanilla, kein Framework)
   ========================================================= */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Geldformat ---------- */
  function formatMoney(cents) {
    var format = T.moneyFormat || '{{amount_with_comma_separator}} €';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    function fmt(num, decimals, thousands, decimal) {
      var n = (num / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    var value;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Ankündigungsleiste ---------- */
  function initRotators() {
    $$('[data-rotator]').forEach(function (track) {
      var items = $$('.announcement__item', track);
      if (items.length < 2 || reduceMotion) return;
      var i = 0;
      var interval = parseInt(track.dataset.interval, 10) || 5000;
      var timer = setInterval(next, interval);
      function next() {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }
      track.addEventListener('mouseenter', function () { clearInterval(timer); });
      track.addEventListener('mouseleave', function () { timer = setInterval(next, interval); });
    });
  }

  /* ---------- Mobile-Menü ---------- */
  function initMenu() {
    var drawer = $('[data-menu-drawer]');
    if (!drawer) return;
    var close = function () { drawer.removeAttribute('open'); };
    $$('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer.querySelector('summary') && drawer.open) { /* summary toggelt nativ */ }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.open) { close(); drawer.querySelector('summary').focus(); } });
    document.addEventListener('click', function (e) {
      if (drawer.open && !drawer.querySelector('.menu-drawer__panel').contains(e.target) && !drawer.querySelector('summary').contains(e.target)) close();
    });
  }

  /* ---------- Suche im Header (Treffer direkt beim Tippen, keine eigene Seite) ---------- */
  function initSearch(ctx) {
    $$('[data-header-search]', ctx).forEach(function (details) {
      if (details._search) return;
      details._search = true;
      var summary = $('summary', details);
      var form = $('[data-search-form]', details);
      var input = $('[data-search-input]', details);
      var results = $('[data-search-results]', details);
      var url = (T.routes && T.routes.predictiveSearch) || '/search/suggest';
      var cache = {}, timer, controller, current = '';

      function open() {
        details.setAttribute('open', '');
        document.documentElement.classList.add('search-open');
        // Direkt im Klick fokussieren, sonst öffnet iOS die Tastatur nicht
        input.focus();
        if (input.value) input.select();
      }
      function close(returnFocus) {
        details.removeAttribute('open');
        document.documentElement.classList.remove('search-open');
        select(-1);
        if (returnFocus) summary.focus();
      }
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        details.open ? close() : open();
      });
      $$('[data-search-close]', details).forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
      details.addEventListener('keydown', function (e) { if (e.key === 'Escape' && details.open) { e.preventDefault(); close(true); } });

      function show(html) {
        results.innerHTML = html;
        results.hidden = !html;
        input.setAttribute('aria-expanded', html ? 'true' : 'false');
        input.removeAttribute('aria-activedescendant');
      }
      function search(q) {
        current = q;
        if (!q) { show(''); return; }
        if (cache[q] !== undefined) { show(cache[q]); return; }
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        details.classList.add('is-loading');
        var params = 'q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url + '?' + params, controller ? { signal: controller.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (text) {
            var el = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-predictive]');
            cache[q] = el ? el.innerHTML.trim() : '';
            if (q === current) show(cache[q]);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (q === current) show('<p class="predictive__empty">' + T.strings.error + '</p>');
          })
          .then(function () { if (q === current) details.classList.remove('is-loading'); });
      }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (!q) { search(''); details.classList.remove('is-loading'); return; }
        timer = setTimeout(function () { search(q); }, 220);
      });

      // Pfeiltasten durch die Treffer, Enter öffnet den markierten Treffer
      function items() { return $$('[data-search-item]', results); }
      function select(i) {
        var list = items();
        list.forEach(function (a, n) { a.parentNode.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
        if (list[i]) {
          input.setAttribute('aria-activedescendant', list[i].parentNode.id);
          list[i].scrollIntoView({ block: 'nearest' });
        } else input.removeAttribute('aria-activedescendant');
        return list[i];
      }
      function selectedIndex() {
        var list = items();
        for (var n = 0; n < list.length; n++) if (list[n].parentNode.getAttribute('aria-selected') === 'true') return n;
        return -1;
      }
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var count = items().length;
        if (!count) return;
        e.preventDefault();
        var i = selectedIndex() + (e.key === 'ArrowDown' ? 1 : -1);
        select(i < -1 ? count - 1 : i >= count ? -1 : i);
      });

      // Enter/„Suchen“ bleibt auf der Seite: Treffer sofort zeigen, auf dem Handy Tastatur einklappen
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var chosen = items()[selectedIndex()];
        if (chosen) { window.location.href = chosen.href; return; }
        clearTimeout(timer);
        search(input.value.trim());
        if (window.matchMedia && window.matchMedia('(hover: none)').matches) input.blur();
      });

      results.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-search-query]');
        if (!btn) return;
        input.value = btn.dataset.searchQuery;
        input.focus();
        search(input.value.trim());
      });
    });
  }

  /* ---------- Schneefall ---------- */
  function initSnow() {
    $$('[data-snow]').forEach(function (canvas) {
      if (reduceMotion) { canvas.remove(); return; }
      var ctx = canvas.getContext('2d');
      var flakes = [];
      var w = 0, h = 0, dpr, running = false, raf;
      function resize() {
        // Auf dem Handy feuert "resize" bei jedem Ein-/Ausblenden der Adressleiste.
        // Nur bei echter Größenänderung neu aufbauen und vorhandene Flocken behalten.
        var nw = canvas.clientWidth, nh = canvas.clientHeight;
        if (nw === w && nh === h) return;
        var sx = w ? nw / w : 1, sy = h ? nh / h : 1;
        w = nw; h = nh;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = w * dpr; canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        flakes.forEach(function (f) { f.x *= sx; f.y *= sy; });
        var count = Math.round(Math.min(90, w / 12));
        while (flakes.length < count) flakes.push(make(true));
        flakes.length = count;
      }
      function make(anywhere) {
        return { x: Math.random() * w, y: anywhere ? Math.random() * h : -10, r: 1 + Math.random() * 2.6, s: .3 + Math.random() * .9, d: Math.random() * Math.PI * 2, o: .35 + Math.random() * .5 };
      }
      function tick() {
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.y += f.s; f.d += .01; f.x += Math.sin(f.d) * .4;
          if (f.y > h + 5) flakes[i] = make(false);
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(255,255,255,' + f.o + ')'; ctx.fill();
        }
        raf = requestAnimationFrame(tick);
      }
      function start() { if (!running) { running = true; tick(); } }
      function stop() { running = false; cancelAnimationFrame(raf); }
      resize();
      var resizeTimer;
      window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 150); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }).observe(canvas);
      } else start();
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    });
  }

  /* ---------- Countdown (deutsche Zeit) ---------- */
  function berlinOffsetMinutes(date) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', timeZoneName: 'shortOffset' }).formatToParts(date);
      var tz = parts.filter(function (p) { return p.type === 'timeZoneName'; })[0].value; // "GMT+1"
      var m = tz.match(/GMT([+-]\d+)(?::(\d+))?/);
      if (m) return parseInt(m[1], 10) * 60 + (m[2] ? parseInt(m[2], 10) : 0);
    } catch (e) {}
    return 60;
  }
  function parseBerlin(str) {
    var m = (str || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    return new Date(utc - berlinOffsetMinutes(new Date(utc)) * 60000);
  }
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var target = parseBerlin(el.dataset.countdown);
      if (!target) return;
      var parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      function update() {
        var diff = Math.max(0, target - new Date());
        var s = Math.floor(diff / 1000);
        parts.d.textContent = pad(Math.floor(s / 86400));
        parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
        parts.m.textContent = pad(Math.floor(s % 3600 / 60));
        parts.s.textContent = pad(s % 60);
        if (diff <= 0) {
          clearInterval(timer);
          var exp = $('.countdown__expired', el);
          if (exp && el.dataset.countdownExpired) {
            exp.textContent = el.dataset.countdownExpired;
            exp.hidden = false;
            $('.countdown__clock', el).hidden = true;
          }
        }
      }
      var timer = setInterval(update, 1000);
      update();
    });
  }

  /* ---------- Einblenden beim Scrollen ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (en.isIntersecting) {
          var el = en.target;
          setTimeout(function () { el.classList.add('is-in'); }, (i % 4) * 80);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track || track._init) return;
    track._init = true;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', root);
    var dots = $$('.gallery__dot', root);
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = index();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    track.addEventListener('scroll', function () { clearTimeout(track._s); track._s = setTimeout(mark, 60); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    root._goToMedia = function (mediaId) {
      slides.forEach(function (s, i) { if (s.dataset.mediaId == mediaId) go(i); });
    };

    var lb = $('[data-lightbox]', root);
    if (lb && typeof lb.showModal === 'function') {
      var lbTrack = $('.lightbox__track', lb);
      $$('[data-zoom]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          lb.showModal();
          var i = +btn.dataset.zoom;
          requestAnimationFrame(function () { lbTrack.scrollLeft = i * lbTrack.clientWidth; });
        });
      });
      $('[data-lightbox-close]', lb).addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target.classList.contains('lightbox__img') || e.target === lb) lb.close(); });
    }
  }

  /* ---------- Varianten ---------- */
  function initVariantPicker(section) {
    var picker = $('[data-variant-picker]', section);
    if (!picker) return;
    var jsonEl = $('[data-variants-json]', picker);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    picker.addEventListener('change', function () {
      var selected = [];
      $$('fieldset', picker).forEach(function (fs, i) {
        var input = $('input:checked', fs);
        selected[i] = input ? input.value : null;
        var label = $('[data-option-value="' + i + '"]', picker);
        if (label && input) label.textContent = input.value;
      });
      var variant = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      updateVariant(section, variant);
    });
  }
  function updateVariant(section, variant) {
    var idInput = $('[data-variant-id]', section);
    var buttons = $$('[data-add-button], .sticky-buy__btn', section.closest('[data-product-section]') || section);
    var label = $('[data-add-label]', section);
    if (!variant) {
      buttons.forEach(function (b) { b.disabled = true; });
      if (label) label.textContent = T.strings.unavailable;
      return;
    }
    if (idInput) idInput.value = variant.id;
    buttons.forEach(function (b) { b.disabled = !variant.available; });
    if (label) label.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
    var root = section.closest('[data-product-section]') || section;
    $$('[data-price-wrapper]', root).forEach(function (w) {
      var cur = $('[data-price]', w), cmp = $('[data-compare-price]', w), badge = $('[data-sale-badge]', w);
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (cur) cur.textContent = formatMoney(variant.price);
      if (cmp) { cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !sale; }
      if (badge) {
        badge.hidden = !sale;
        if (sale) badge.textContent = badge.textContent.replace(/\d+/, Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price));
      }
      w.classList.toggle('price--sale', !!sale);
    });
    updateBundlePrices(root, variant);
    if (variant.featured_media) {
      var gal = $('[data-gallery]', root);
      if (gal && gal._goToMedia) gal._goToMedia(variant.featured_media.id);
    }
    if (root.hasAttribute('data-product-url') && $('.product', document) && root.classList.contains('product')) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- Mengenrabatt („Bündle & Spare“) ---------- */
  // Die gewählte Stufe setzt die Menge im Kaufformular. Abgezogen wird der
  // Rabatt von einem automatischen Shopify-Rabatt – hier nur die Anzeige.
  function syncBundle(option) {
    var bundle = option.closest('[data-bundle]');
    var form = bundle && document.getElementById(bundle.dataset.form);
    var qty = form && $('[data-bundle-qty]', form);
    if (qty) qty.value = option.dataset.qty;
  }
  function initBundles(ctx) {
    $$('[data-bundle-option]:checked', ctx).forEach(syncBundle);
  }
  function updateBundlePrices(root, variant) {
    $$('[data-bundle-option]', root).forEach(function (opt) {
      var card = opt.nextElementSibling;
      var regular = variant.price * (parseInt(opt.dataset.qty, 10) || 1);
      var saving = Math.min(parseInt(opt.dataset.discount, 10) || 0, regular);
      var price = $('[data-bundle-price]', card), cmp = $('[data-bundle-compare]', card), save = $('[data-bundle-saving]', card);
      if (price) price.textContent = formatMoney(regular - saving);
      if (cmp) cmp.textContent = formatMoney(regular);
      if (save) save.textContent = formatMoney(saving);
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-bundle-option]')) syncBundle(e.target);
  });

  /* ---------- Mengenwähler ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ---------- Warenkorb ---------- */
  var drawer = null;
  var lastFocus = null;

  function openDrawer() {
    drawer = drawer || $('[data-cart-drawer]');
    if (!drawer) { window.location.href = T.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.drawer__panel', drawer);
    setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = $('[data-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', !count); });
    if (!count) store(function (s) { s.removeItem(TIMER_KEY); });
  }

  /* ---------- Warenkorb reserviert (Timer) ---------- */
  // Die Ablaufzeit wird einmal festgelegt und bleibt beim Neuladen gleich.
  // Wird der Warenkorb geleert, beginnt der Timer beim nächsten Mal neu.
  var TIMER_KEY = 'tb-cart-reserved-until';
  var timerInterval = null;
  function store(fn) { try { return fn(window.localStorage); } catch (e) { return null; } }
  function clearExpiredTimer() {
    store(function (s) { var end = parseInt(s.getItem(TIMER_KEY), 10); if (end && end <= Date.now()) s.removeItem(TIMER_KEY); });
  }
  function initCartTimers() {
    clearInterval(timerInterval);
    var els = $$('[data-cart-timer]');
    if (!els.length) {
      // Kein Timer auf der Seite = Warenkorb leer (die Schublade ist auf jeder Seite)
      if ($('[data-cart-inner]')) store(function (s) { s.removeItem(TIMER_KEY); });
      return;
    }
    var total = (parseInt(els[0].dataset.minutes, 10) || 10) * 60000;
    var end = parseInt(store(function (s) { return s.getItem(TIMER_KEY); }), 10);
    if (!end) {
      end = Date.now() + total;
      store(function (s) { s.setItem(TIMER_KEY, String(end)); });
    }
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function tick() {
      var left = Math.max(0, end - Date.now());
      var secs = Math.ceil(left / 1000);
      els.forEach(function (el) {
        var time = $('[data-cart-timer-time]', el), fill = $('[data-cart-timer-fill]', el), label = $('[data-cart-timer-label]', el);
        if (time) time.textContent = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60);
        if (fill) fill.style.width = Math.min(100, left / total * 100) + '%';
        if (!left && !el.classList.contains('is-expired')) {
          el.classList.add('is-expired');
          if (label && el.dataset.expiredText) label.textContent = el.dataset.expiredText;
        }
      });
      if (!left) clearInterval(timerInterval);
    }
    tick();
    timerInterval = setInterval(tick, 1000);
  }
  function refreshCount() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); return c; });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); openDrawer(); return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var f = $$('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', drawer)).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // In den Warenkorb (Produktseite, Fokus-Produkt, Karten)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]') || document.querySelector('[form="' + form.id + '"]');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    var buttons = $$('[type="submit"]', form).concat(form.id ? $$('[form="' + form.id + '"]') : []);
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
    fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || T.strings.error);
        clearExpiredTimer();
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        if (res.body.sections) renderDrawer(res.body.sections['cart-drawer']);
        initCartTimers();
        refreshCount();
        openDrawer();
      })
      .catch(function (error) {
        if (err) { err.textContent = error.message; err.hidden = false; } else toast(error.message);
      })
      .finally(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); b.disabled = false; });
      });
  });

  // Mengen im Warenkorb ändern
  function changeLine(lineEl, qty) {
    var line = parseInt(lineEl.dataset.line, 10);
    lineEl.classList.add('is-loading');
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) throw new Error(cart.description || T.strings.error);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
        updateCount(cart.item_count);
        initCartTimers();
      })
      .catch(function (error) { toast(error.message); lineEl.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-line-change]');
    var rm = e.target.closest('[data-line-remove]');
    if (!ch && !rm) return;
    var lineEl = (ch || rm).closest('[data-line]');
    var input = $('[data-line-qty]', lineEl);
    var qty = rm ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(ch.dataset.lineChange, 10));
    changeLine(lineEl, qty);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-qty]')) return;
    changeLine(e.target.closest('[data-line]'), Math.max(0, parseInt(e.target.value, 10) || 0));
  });

  /* ---------- Sticky Kaufen-Leiste ---------- */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var main = $('[data-main-buy]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = $('.sticky-buy__btn', bar);
    new IntersectionObserver(function (en) {
      var past = en[0].boundingClientRect.top < 0;
      var show = !en[0].isIntersecting && past;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    }).observe(main);
  }

  /* ---------- Slider (Bewertungen) ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (s) {
      var track = $('[data-slider-track]', s);
      var step = function () { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 20 : track.clientWidth; };
      var prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Produktempfehlungen ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var load = function (url) {
        return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          return fresh && fresh.querySelector('.product-grid') ? fresh.innerHTML : null;
        });
      };
      var url = el.dataset.url;
      if (!url) return;
      load(url).then(function (inner) {
        if (inner) { el.innerHTML = inner; return; }
        if (url.indexOf('intent=complementary') > -1) {
          return load(url.replace('intent=complementary', 'intent=related')).then(function (inner2) { if (inner2) el.innerHTML = inner2; });
        }
      }).catch(function () {});
    });
  }

  /* ---------- Sonstiges ---------- */
  function initMisc() {
    var sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    var login = $('[data-login]');
    if (login) {
      var showRecover = function (show) {
        $('[data-login-panel]', login).hidden = show;
        $('[data-recover-panel]', login).hidden = !show;
      };
      $$('[data-show-recover]', login).forEach(function (b) { b.addEventListener('click', function () { showRecover(true); }); });
      $$('[data-hide-recover]', login).forEach(function (b) { b.addEventListener('click', function () { showRecover(false); }); });
      if (window.location.hash === '#recover') showRecover(true);
    }
    $$('form[data-confirm]').forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm(f.dataset.confirm)) e.preventDefault(); });
    });
    $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
  }

  function init() {
    initRotators();
    initMenu();
    initSearch(document);
    initSnow();
    initCountdowns();
    initReveal();
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-product-section]').forEach(initVariantPicker);
    initBundles(document);
    initCartTimers();
    initStickyBuy();
    initSliders();
    initRecommendations();
    initMisc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: Sections nach dem Neuladen initialisieren
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-gallery]', t).forEach(initGallery);
    $$('[data-product-section]', t).forEach(initVariantPicker);
    initBundles(t);
    initSearch(t);
    initCartTimers();
    initRotators(); initCountdowns(); initReveal(); initSliders();
    $$('.reveal', t).forEach(function (el) { el.classList.add('is-in'); });
    if (t.querySelector('[data-snow]')) initSnow();
  });
})();
